import { useQuery } from 'react-query';
import TradeCountService from '../../../services/TradeCountService';
import { TRADE } from '../../constants/queryDefinition';
import { TradeContext } from '../../types/trade';

const useTradeCount = (context?: TradeContext) => {
  async function getTradeCount() {
    return TradeCountService.getTradeCount(context);
  }

  const tradeCountList = useQuery(
    `${TRADE.COUNT.KEY}-${context}`,
    getTradeCount,
    {
      enabled: true,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: TRADE.COUNT.REFETCH_INTERVAL,
      staleTime: TRADE.COUNT.REFETCH_INTERVAL,
      placeholderData: {},
      retry: false
    }
  );

  return tradeCountList?.data?.body?.tradeCountStateSummaries;
};

export default useTradeCount;
